const NewsPage = ({ attributes }) => {
    const { newsPage = {}, primaryColor = '#ff0037' } = attributes;
    const {
        title = 'News',
        subtitle = 'Latest Updates',
        description = '',
        heroImage = '',
        items = [],
    } = newsPage;

    return (
        <div className="gmf-page-wrapper">
            <section
                className="gmf-page-hero"
                style={heroImage ? {
                    backgroundImage: `linear-gradient(rgba(0,0,0,0.62), rgba(0,0,0,0.62)), url(${heroImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                } : {}}
            >
                <div className="gmf-page-hero-inner">
                    {subtitle ? <p className="gmf-page-eyebrow" style={{ color: primaryColor }}>{subtitle}</p> : null}
                    <h1 className="gmf-page-title">{title}</h1>
                    <div className="gmf-divider gmf-divider--center" />
                    {description ? <p className="gmf-page-subtitle">{description}</p> : null}
                </div>
            </section>

            <section className="gmf-privacy-sections" style={{ maxWidth: 1000, margin: '0 auto 48px', padding: '0 20px' }}>
                {(items || []).map((item, index) => (
                    <div key={item.id || index} className="gmf-privacy-section-card">
                        {item.image ? (
                            <div style={{ marginBottom: 16 }}>
                                <img
                                    src={item.image}
                                    alt={item.title || 'News image'}
                                    style={{ width: '100%', maxHeight: 280, objectFit: 'cover', borderRadius: 12 }}
                                />
                            </div>
                        ) : null}
                        <div className="gmf-privacy-section-header">
                            <h2 className="gmf-privacy-section-title">{item.title}</h2>
                        </div>
                        <div className="gmf-privacy-section-content">
                            {item.date ? <p style={{ color: primaryColor, marginBottom: 8 }}>{item.date}</p> : null}
                            <p>{item.summary}</p>
                            {item.link ? (
                                <p style={{ marginTop: 12 }}>
                                    <a href={item.link} target="_blank" rel="noopener noreferrer" style={{ color: primaryColor }}>
                                        Read more
                                    </a>
                                </p>
                            ) : null}
                        </div>
                    </div>
                ))}
            </section>
        </div>
    );
};

export default NewsPage;
